module.exports = __webpack_public_path__ + "img/744.4f1bc3e2.jpg";